module.exports = "https://static-production.npmjs.com/6d9930e83bbb43bba93e22eda2871b55.svg";